export default function goBack (props) {
    return props.history.push({
        pathname: props.location.state.goBackUrl, 
        state: 
            { 
                searchConds : props.location.state.searchConds, 
                id : props.location.state.id
            }
        });
}